import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  addMenusImages,
  deleteMenu,
  getMenuList,
  uplaodMedia,
} from 'app/api/store';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { confirmAlert } from 'react-confirm-alert';

const useCreateMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const storeId = location?.state?.id ? location?.state?.id : '';

  const [imageUploadArray, setimageUploadArray] = useState([]);
  const [menuImagesArray, setmenuImagesArray] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    loadStoreData();
  }, []);

  async function loadStoreData() {
    if (!storeId) {
      return;
    }
    setPageLoading(true);
    let response = await getMenuList(storeId);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;

      setmenuImagesArray(responsedata);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  async function callAddMenuAPI() {
    setPageLoading(true);
    let response = {};
    response = await addMenusImages(imageUploadArray);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      Toast.success(Message.Menus.CREATED_SUCCESS);
      setimageUploadArray([]);
      loadStoreData();
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  function handleCreateMenu() {
    let valueCpy = [...imageUploadArray];
    let hasError = false;

    valueCpy.forEach((element, index) => {
      if (!element.menu) {
        element['error'] = 'Please Add Menu Image';
        hasError = true;
      }
    });
    setimageUploadArray([...valueCpy]);
    if (hasError) {
      return;
    }
    callAddMenuAPI();
  }

  function handleChange(name, value, id) {
    let valueCpy = [...imageUploadArray];
    valueCpy.forEach((element, index) => {
      if (element.addid === id) {
        element[name] = value;
        element['error'] = '';
      }

      return element;
    });
    setimageUploadArray([...valueCpy]);
  }
  function removeArrayItemById(index) {
    console.log('index', index, imageUploadArray);
    if (index !== -1) {
      imageUploadArray.splice(index, 1);
      setimageUploadArray([...imageUploadArray]);
    }
  }
  async function uploadMediaHandler(file, name, id, index) {
    if (!file) {
      removeArrayItemById(index, id);

      return;
    }
    const response = await uplaodMedia(file);
    if (response.responseCode === 200) {
      Toast.success('Image upload Successfull');
      const data = await response.data;
      handleChange(name, data?.url, id);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  const callServiePublishOrUnpublishAPI = async (data) => {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteMenu(data?.id);
      setPageLoading(false);
      if (responseObj?.responseCode === 200) {
        loadStoreData();
        Toast.success('Menu Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : Message.Error.COMMON_MESSAGE
        );
      }
    } else {
      Toast.error('Failed to delete');
    }
  };
  const handleDelete = (data) => {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            callServiePublishOrUnpublishAPI(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  };
  function addImage() {
    const uniqueAddId = `addid-${Date.now()}`;
    const newItem = {
      menu: '',
      storeId,
      status: true,
      addid: uniqueAddId,
      error: '',
    };
    setimageUploadArray([...imageUploadArray, newItem]);
  }
  return {
    addImage,
    imageUploadArray,
    menuImagesArray,
    pageLoading,
    storeId,
    uploadMediaHandler,
    navigate,
    handleCreateMenu,
    handleDelete,
  };
};

export default useCreateMenu;
